import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82fe8316"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-eventsStart" }
const _hoisted_2 = { class: "uf-button" }
const _hoisted_3 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_form_item_group = _resolveComponent("sub-form-item-group")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_uf_form = _resolveComponent("uf-form")!
  const _component_uf_department = _resolveComponent("uf-department")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_uf_form, {
        "show-error": "",
        "scroll-to-error": "",
        "show-error-message": false
      }, {
        default: _withCtx(() => [
          (_ctx.tempInfo)
            ? (_openBlock(), _createBlock(_component_sub_form_item_group, {
                key: 0,
                id: _ctx.$route.params.id,
                list: _ctx.tempInfo,
                ref: "subFormItemGroupRef"
              }, null, 8, ["id", "list"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_van_button, {
                class: "btn",
                block: "",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" 提交 ")
                      ], 64))
                    : (_openBlock(), _createBlock(_component_van_loading, { key: 1 }))
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_uf_department, {
      data: _ctx.departmentInfo.list,
      show: _ctx.departmentInfo.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.departmentInfo.show) = $event)),
      onConfirm: _ctx.departmentInfo.confirm,
      multiple: false
    }, null, 8, ["data", "show", "onConfirm"])
  ], 64))
}